"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.strategistTitleList = void 0;
exports.strategistTitleList = [
    {
        label: 'Strategist',
        value: 'strategist',
    },
    {
        label: 'Senior Strategist',
        value: 'senior strategist',
    },
    {
        label: 'Principal Strategist',
        value: 'principal strategist',
    },
    {
        label: 'Regional Manager',
        value: 'region manager',
    },
    {
        label: 'Regional Team Lead',
        value: 'region team lead',
    },
    {
        label: 'Team Lead',
        value: 'team lead',
    },
    {
        label: 'Program Manager',
        value: 'program manager',
    },
    {
        label: 'Project Lead',
        value: 'project lead',
    },
    {
        label: 'Platinum',
        value: 'platinum',
    },
];
//# sourceMappingURL=staffTitleList.js.map